import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Link, RouteComponentProps} from 'react-router-dom';
import {Button, Col, Row} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {IRootState} from 'app/shared/reducers';
import {getEntity} from './village.reducer';
import {useTranslation} from 'app/shared/util/translation-utils';

export interface IVillageDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {
}

export const VillageDetail = (props: IVillageDetailProps) => {
  const { t } = useTranslation();
  
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const {villageEntity} = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          {t('village.detail.id', { id: villageEntity.id })}
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="name">{t('common.fields.name')}</span>
          </dt>
          <dd>{villageEntity.name}</dd>
          <dt>
            <span id="pickupLocation">{t('village.fields.pickupLocation')}</span>
          </dt>
          <dd>{villageEntity.pickupLocation}</dd>
          <dt>
            <span id="locationLat">{t('common.fields.latitude')}</span>
          </dt>
          <dd>{villageEntity.locationLat}</dd>
          <dt>
            <span id="locationLon">{t('common.fields.longitude')}</span>
          </dt>
          <dd>{villageEntity.locationLon}</dd>
          <dt>{t('common.fields.council')}</dt>
          <dd>{villageEntity.council ? villageEntity.council.name : ''}</dd>
          <dt><span>{t('common.fields.contactName')}</span></dt>
          <dd>{villageEntity.contactName}</dd>
          <dt><span>{t('common.fields.phoneNumber')}</span></dt>
          <dd>{villageEntity.phoneNumber}</dd>
        </dl>
        <Button tag={Link} to="/village" replace color="info">
          <FontAwesomeIcon icon="arrow-left"/> <span className="d-none d-md-inline">{t('common.actions.back')}</span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({village}: IRootState) => ({
  villageEntity: village.entity,
});

const mapDispatchToProps = {getEntity};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(VillageDetail);
